import { useApiClient } from 'bff/ApiClientProvider';
import { queryOptions } from '@tanstack/react-query';
import { ReportingGetClientBankAccountsRequest } from 'bff/client';

export const getBankAccounts = (request: ReportingGetClientBankAccountsRequest) => {
  const { reportingApi } = useApiClient();

  return queryOptions({
    queryKey: ['BankAccounts'],
    queryFn: () => reportingApi.reportingGetClientBankAccounts(request),
    select: (response) => response.data
  });
};
